export default {
  AVAILABILITY_SLOT_CREATE: 'calendar:availability_slot_create',
  AVAILABILITY_SLOT_UPDATE: 'calendar:availability_slot_update',
} as const;
